import { Injectable} from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { Company } from '../_models/company';
import { LoginData } from '../_models/loginData';
import { beatBlipSubscriptionConsts } from '../consts/beatBlipSubscriptionConsts';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpHeaders} from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { User } from '../_models/user';
import { DOCUMENT } from '@angular/common';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
   
    private url : string;
    public userRole = new BehaviorSubject(null);
    public userList =  new BehaviorSubject(null);
    constructor(
        private http: HttpClient,
        private toastr: ToastrService,
        private router: Router,
        private cookieService: CookieService,
        @Inject( DOCUMENT ) private document: Document){
	 this.url=environment.baseUrl;
           /* this.url = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port;
            //+"8080";*/
        }
        

    register(user, response) {        

        const company = new Company();
        company.companyName = user.companyName;
        user.companyAccount = company;

          var boundary = Math.random().toString().substr(2);
          var header = "multipart/form-data; charset=utf-8; boundary=" + boundary;
          var data = createRequest(JSON.stringify(user), JSON.stringify(response), boundary);

          function createRequest(user, captchaResponse, boundary) {
              var multipart = "";
              multipart += "--" + boundary +
                  "\r\nContent-Disposition: form-data; name=userData" +
                  "\r\nContent-type: application/json" +
                  "\r\n\r\n" + user + "\r\n";
              multipart += "--" + boundary +
                  "\r\nContent-Disposition: form-data; name=captcha" +
                  "\r\nContent-type: application/json" +
                  "\r\n\r\n" + captchaResponse + "\r\n";
              multipart += "--" + boundary + "--\r\n";
              return multipart;
          }

          var config = {
              headers: {
                  'Content-Type': header
              }
          };

        
            // tslint:disable-next-line: max-line-length
            this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/create-free-user',data,config).subscribe(res => {
            if (res) {
                this.toastr.clear();
                this.toastr.success(beatBlipSubscriptionConsts.SIGNUP_INFO);               
                this.router.navigate(['/login']);
            }
            else
            {
                this.toastr.clear();
                this.toastr.warning("User already exist, please try with other username");
            }
        }, error => {
            if (error.error && error.error.appStatusCode) {
                this.toastr.clear();
                this.toastr.error(error.error.message);
            }
           // console.log('This is being done', error);
            });
         
    }

    ssoLogin(ssoModel){
        const httpOptions = new HttpHeaders();

        var myItem = localStorage.getItem("graphData");
        localStorage.clear();
        if(myItem)
        {
            localStorage.setItem("graphData", myItem);
        }
        httpOptions.set('Access-Control-Allow-Origin','*');

      return  this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/sso/createuser`, ssoModel)
 
    }
  azureLoginCheck(ssoModel){

      return  this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/login-user-sso`, ssoModel)

    }

    login(user)  {
        var rememberUser = false; 
        rememberUser = user.remember;
        const httpOptions = new HttpHeaders();
        var myItem = localStorage.getItem("graphData");
        localStorage.clear();
        if(myItem)
        {
            localStorage.setItem("graphData", myItem);
        }
        httpOptions.set('Access-Control-Allow-Origin','*');
      return  this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/login-user`, user, {headers: httpOptions})
    }
    verifyUser(verifyKey: string) {
        const  params = new  HttpParams({fromString: 'verifyKey=' + verifyKey});
        this.http.request('GET', this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/validate-user/' + verifyKey).
        subscribe((data: LoginData) => {
            if (data) {
                 var expireDate = new Date();
                 expireDate.setHours(23, 59, 0, 0);
                   // data.user_name = user.userName;
                   this.cookieService.set('loginSubscriptionData', JSON.stringify(data),2345,"/");
                   this.router.navigate(['/Dashboard']);
            }
        }, error => {
             this.toastr.clear();
             if (error.error && error.error.appStatusCode) {
                    this.toastr.error(error.error.message);
                    }
         });
    }
    forgotPassword(user,cancelModel) {
        this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/forgot-password`, user).
        subscribe((data: LoginData) => {
                this.toastr.clear();
                this.toastr.success(beatBlipSubscriptionConsts.FORGOT_PASSWORD);
                cancelModel.nativeElement.click();
                this.router.navigate(['/login']);
            
        }, error => {
          //  console.log(error);
        });
    }
    changePassword(passwordData) {
        if(passwordData.password === passwordData.newPassword) {
            this.toastr.info("Current and new password must not be the same");
            return;
        }
        
       var loginData = new LoginData();
       loginData.password = passwordData.password;
       loginData.newPassword = passwordData.newPassword;
       this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/change-password',loginData ).
       subscribe((data: LoginData) => {
        //if(data) {
            this.toastr.clear();
            this.toastr.success(beatBlipSubscriptionConsts.PASSWORD_CHANGED);
            this.cookieService.delete('loginSubscriptionData',"/");
            this.router.navigate(['/login']);
        //}
       });
    }
    
    getApiAcessToken() {
        this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/api-token').subscribe((tokenData:any) => {
          //  console.log(tokenData);
            this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/fService/fsDataSfIntegration').subscribe((data:any) => {
                //console.log(data);
                var userFeatures = data.userFeatures;
                let body = new FormData();
                body.append('is_all_enable', '0');
                for(var i =0 ;i<userFeatures.length;i++) {
        
                    if(userFeatures[i].isFeatureSelected == 'true')
                    	 body.append(userFeatures[i].featureNm, '1');
                    else 
                        body.append(userFeatures[i].featureNm, '0');
                        
                }
               
				// body.append('android_sa', '1');
				// body.append('android_da', '0');
				// body.append('ios_sa', '0');
				body.append('UserName', tokenData.email);
				body.append('AccessToken', tokenData.accessToken);
                this.http.post(beatBlipSubscriptionConsts.AGREEYA_SF_URL, body).subscribe(res => {
                   // console.log(res)
                },  error => {
           			// console.log(error);
        		});
            });
           
        });
       
    }

    getUser() {
        return this.http.get<User>(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/current-user');
    }

    getUserType(id) {
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/getCustomerProfile/'+id);
    }

    updateImage(image, userId)
    {
        let body = new FormData();
        body.append('profile', image);
        return this.http.post(this.url +  beatBlipSubscriptionConsts.BASE_URL + '/access/update-profile/' +  userId, body);
    }

    deleteImage(profileId)
    {
        return this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/delete-profile/' + profileId, null);
    }

    getUserById(userId)
    {  
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL  + '/access/getUserById/' + userId);
    }

    getUserProfileById(userId)
    {
        return this.http.get(this.url + beatBlipSubscriptionConsts.BASE_URL + '/access/getUserProfileById/' + userId, { responseType : 'text'});
    }

    logoutUser(){
        this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/logout-user`, '').
        subscribe((data: LoginData) => {
            this.toastr.clear();
            this.toastr.success(beatBlipSubscriptionConsts.LOGOUT_SUCCESSFULLY);
            this.cookieService.delete('loginSubscriptionData',"/");
            this.cookieService.delete('loginData',"/BeatBlipUI");
            var myItem = localStorage.getItem("graphData");
            localStorage.clear();
            if(myItem)
            {
                localStorage.setItem("graphData", myItem);
            }

            this.getLoginFlag().subscribe(
                (res:any)=>{
                    // if(res[0].value=='true'){
                       var logoutUrlFlag;
                        res = res['configFlags']
                        res.forEach(element => {
                            if(element.name=='azureEnabled' && element.value=='true'){                    
                                logoutUrlFlag = true;
                            }
                            if(logoutUrlFlag && element.name=='logoutServerUrl'){
                                var logoutUrl = element.value;
                                let updatedString = logoutUrl.replace("{logoutServerUrl}", this.url + '/HuLoopSubscriptionUI');
                                window.open(updatedString,'_blank'); 
                            }
                        });
                       
                        this.router.navigate(['/login']);
                    // }
                
          
                }
            )
        });
    }
 
    resetpassword(user,queryParams)  {
        const httpOptions = new HttpHeaders();
        httpOptions.set('Access-Control-Allow-Origin','*');
      return  this.http.post(this.url + beatBlipSubscriptionConsts.BASE_URL + `/access/forgot-password?resetId=` + queryParams, user, {headers: httpOptions})
    }
    getLicenceUser(domain) {
        return this.http.get(this.url+'/HuLoopRest/huloop/access/companyAcctUsers/'+domain)
      }

    setUserList(list) {
        this.userList.next(list);
    }

    getUserList()
    {
        return this.userList.asObservable();
    }

    getLoginFlag(){
       
        return this.http.get(this.url+'/HuLoopRest/huloop/configflags/')
    }

    generateToken(dateInMillis,body){

        return this.http.put(this.url+'/HuLoopRest/huloop/access/generatetoken/'+dateInMillis,body, {responseType: 'text'});
    }
    logOutSso(serverurl){
        return this.http.get(this.url+serverurl)
    }
    
    deleteToken(email){

        return this.http.put(this.url+'/HuLoopRest/huloop/access/deletetoken/'+email, {responseType: 'text'});
    }
}
